import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { setMobileMenuState } from '@Header/Navigation/ducks/actions';
import { useAnalytics } from '@Shared/useAnalytics';
import AboutCarvana from './AboutCarvana';
import Account from '../../Account';
import Financing from './Financing';
import HowItWorks from './HowItWorks';
import Search from './Search';
import SellTrade from './SellTrade';
import InnerDrawer from '../../../Shared/InnerDrawer';
import DrawerTitle from '../../../Shared/DrawerTitle';
import Icon from '../../../Shared/Icons';
import Drawer from '../../../Shared/Drawer';
import { getIsMobileMenuExpanded } from '../../ducks/selectors';
import { StyledMenuButton, StyledMenuDrawerItem } from './HeaderMenuMobile.styles';

const HamburgerWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;

const StyledHamburger = styled.div`
  display: flex;
  width: 20px;
  height: 12px;
  fill: ${(props) => props.theme.carvana.blue.dark};
`;

const HeaderMenuInnerDrawer = styled(InnerDrawer)``;

const HeaderMenuDrawerTitle = styled(DrawerTitle)`
  position: relative;
  z-index: 9;
`;

const ExtraSpaceForBottom = styled.div`
  height: 60px;
`;

const HeaderMenuMobile = ({
  partner,
  screenHeight,
  isMobileMenuExpanded,
  dispatch,
  purchaseProcessVehiclePrice,
  shouldShowCarvanaFinancing,
}) => {
  const { trackEvent, trackEventAndGo } = useAnalytics();

  const handleMainNavClick = (ev, name) => {
    const href = ev?.target?.href || '';
    if (href === '/my-carvana') {
      trackEvent('my_carvana_nav_link_tap');
    }
    trackEventAndGo(ev, 'clicked main nav link', {
      platform: 'mobile',
      link: name,
      partner: partner?.partnerVanityUrlName
    });
  };

  const openHamburgerMenu = () => {
    trackEvent('user platform - header - expanded hamburger menu', { platform: 'mobile' });
    dispatch(setMobileMenuState(!isMobileMenuExpanded));
  };

  return (
    <Fragment>
      <HamburgerWrapper>
        <StyledHamburger
          data-cv-test="headerMobileMenuOpen"
          onClick={openHamburgerMenu}
        >
          <Icon iconName="hamburger" />
        </StyledHamburger>
      </HamburgerWrapper>
      <Drawer
        anchor="right"
        isOpen={isMobileMenuExpanded}
        onTouchMove={(e) => e.stopPropagation()}
      >
        <HeaderMenuInnerDrawer
          screenHeight={screenHeight}
          className="header-menu-mobile-drawer"
        >
          <HeaderMenuDrawerTitle
            close={() => dispatch(setMobileMenuState(!isMobileMenuExpanded))}
            title="Menu"
          />
          <Account purchaseProcessVehiclePrice={purchaseProcessVehiclePrice} />
          <Search handleMainNavClick={handleMainNavClick} />
          <SellTrade handleMainNavClick={handleMainNavClick} />
          <Financing
            partner={partner}
            handleMainNavClick={handleMainNavClick}
            shouldShowCarvanaFinancing={shouldShowCarvanaFinancing}
          />
          <StyledMenuDrawerItem>
            <StyledMenuButton
              dataCvTest="headerMobileMyCarvanaLink"
              href="/my-carvana"
              target="_self"
              onClick={e => handleMainNavClick(e, 'My Cars')}
            >
              My Cars
            </StyledMenuButton>
          </StyledMenuDrawerItem>
          <HowItWorks />
          <AboutCarvana />
          <ExtraSpaceForBottom />
        </HeaderMenuInnerDrawer>
      </Drawer>
    </Fragment>
  );
};

HeaderMenuMobile.propTypes = {
  partner: PropTypes.shape({}),
  screenHeight: PropTypes.number.isRequired,
  isMobileMenuExpanded: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  purchaseProcessVehiclePrice: PropTypes.number.isRequired,
  shouldShowCarvanaFinancing: PropTypes.bool,
};

HeaderMenuMobile.defaultProps = {
  partner: {
    partnerVanityUrlName: 'notused',
  }
};

const mapStateToProps = state => {
  return {
    isMobileMenuExpanded: getIsMobileMenuExpanded(state),
  };
};

export default connect(mapStateToProps, null)(HeaderMenuMobile);
